import { useCallback, useState } from 'react';

export function useExpandable(initial: boolean = false) {
  const [isExpanded, setIsExpanded] = useState(initial);
  const toggleExpanded = useCallback(() => setIsExpanded((prev) => !prev), []);
  return { isExpanded, setIsExpanded, toggleExpanded };
}

export default useExpandable;
